// Shared CSRF helper for /api/app write calls. The MVC page hosting the Vue island renders
// @Html.AntiForgeryToken() as a hidden input; the value must be echoed back in this header
// for [ValidateHeaderAntiForgeryTokenApi] to accept the request.
export const ANTIFORGERY_TOKEN_HEADER = '__RequestVerificationToken';

export function readAntiforgeryToken(): string {
    const input = document.querySelector<HTMLInputElement>('input[name="__RequestVerificationToken"]');
    return input?.value ?? '';
}
